/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, price: NonNullable<unknown> }} Plan_Choice_OptionInputs */

const fr_plan_choice_option = /** @type {(inputs: Plan_Choice_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajouter l'option ${i?.label} (${i?.price})`)
};

/**

* @param {Plan_Choice_OptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_option = /** @type {((inputs: Plan_Choice_OptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_OptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_option(inputs)
});